import { z } from 'zod'

import { Pagination } from 'app/types/app/request'

/** Category used in multiple objects. */
export const Category = z.object({
    /** Category ID. */
    id: z.number().positive(),

    /** Name of the category. */
    name: z.string().min(1),

    /** Priority of the category. */
    priority: z.number().positive(),
})

export type Category = z.infer<typeof Category>

/** Categories list request. */
export const CategoriesRequest = Pagination.extend({
    results: Category.array(),
})

export type CategoriesRequest = z.infer<typeof CategoriesRequest>
